<template>
    <div>
        <div class="input-group">
            <div class="input-group-prepend" v-show="loading">
                <div class="input-group-text">
                    <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                    ></span>
                </div>
            </div>
            <input
                class="form-control"
                type="text"
                :placeholder="__('general.brand_name')"
                v-model="query"
                @keyup.prevent="queueSearch"
            />
        </div>
        <div v-show="results === undefined">
            <small class="form-text text-muted">
                {{ __("product.brand_section.choose_producer") }}
            </small>
            <small v-show="userBrandsOnly" class="form-text text-muted">
                {{ __("product.brand_section.attention_no_ean") }}
            </small>
        </div>
        <div v-show="!loading && results !== undefined">
            <ul
                v-if="results !== undefined && results.length > 0"
                class="list-group"
            >
                <li
                    v-for="brand in results"
                    class="list-group-item"
                    @click="$emit('selectBrand', brand)"
                    v-html="brand.name"
                ></li>
            </ul>
            <div v-else>
                <label class="h5 my-5">
                    {{ __("product.brand_section.brand_not_found") }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import CreateUserBrand from "../Brand/CreateUserBrand";

export default {
    name: "NewArticleBrand",
    components: { CreateUserBrand },
    data() {
        return {
            query: "",
            results: undefined,
            lastKeyStroke: undefined,
            waitingForSearch: false,
            selected: {},
            loading: false,
        };
    },
    props: {
        userBrandsOnly: Boolean,
        oldValue: Object,
    },
    mounted() {
        if (!_.isEmpty(this.oldValue)) {
            this.$emit("selectBrand", this.oldValue);
        }
    },
    methods: {
        setBrand(data) {
            this.$emit("selectBrand", data);
        },

        queueSearch() {
            //required to reduce API spam
            this.lastKeyStroke = new Date();

            if (!this.waitingForSearch) {
                this.waitingForSearch = true;
                setTimeout(this.search, 100);
            }
        },

        async search() {
            let now = new Date();
            let secondsPassedSinceLastKeyStroke =
                now.getTime() - this.lastKeyStroke.getTime();
            if (secondsPassedSinceLastKeyStroke > 400) {
                this.waitingForSearch = false;
                let part = this.query;
                if (part.length > 1) {
                    this.loading = true;
                    if (this.userBrandsOnly) {
                        let { data } = await axios.get(
                            this.$route("user_brands", {
                                part: part,
                            })
                        );
                        this.results = data;
                    } else {
                        let { data } = await axios.post(
                            this.$route("search-brand"),
                            {
                                name: part,
                            }
                        );
                        this.results = data.data;
                    }

                    this.loading = false;
                } else {
                    this.results = [];
                }
            } else {
                setTimeout(this.search, 100);
            }
        },
    },
};
</script>

<style scoped>
.list-group-item {
    cursor: pointer;
}
</style>
